import React from 'react';
import { View, Text } from 'react-native';
import { ChevronRight } from 'lucide-react-native';
import { useThemeColors } from '@/lib/useThemeColors';
import AnimatedPressable from '@/components/AnimatedPressable';

interface QuickActionItem {
  label: string;
  count: number;
  icon: React.ReactNode;
  onPress: () => void;
}

interface QuickActionsProps {
  items: QuickActionItem[];
}

export function QuickActions({ items }: QuickActionsProps) {
  const colors = useThemeColors();

  return (
    <View className="gap-2">
      {items.map((item, i) => (
        <AnimatedPressable
          key={i}
          onPress={item.onPress}
          className="flex-row items-center gap-3 p-3 rounded-xl"
          style={{ backgroundColor: colors.surface.secondary }}
        >
          {item.icon}
          <View className="flex-1">
            <Text style={{ color: colors.text.primary }} className="text-sm font-medium">
              {item.label}
            </Text>
          </View>
          <View
            className="px-2 py-0.5 rounded-full mr-1"
            style={{ backgroundColor: `${colors.primary[600]}15` }}
          >
            <Text style={{ color: colors.primary[600] }} className="text-xs font-bold">
              {item.count}
            </Text>
          </View>
          <ChevronRight size={14} color={colors.text.tertiary} />
        </AnimatedPressable>
      ))}
    </View>
  );
}
